<script>
  export let style = '';

  import jQuery from 'jquery';

  let goToTop = function () {
    jQuery(window).scrollTop(0);
  };
</script>

<style style="text/scss" lang="scss">
  .back-to-top-btn {
    position: absolute;
    left: calc(50% - 46px);
    background: #ffffff;
    border: 2px solid #ffffff;
    border-radius: 20px;
    width: 92px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    span {
      margin-right: 9px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }

    &:hover {
      span {
        color: #a893f9;
      }
    }
  }
</style>

<div class="back-to-top-btn" style={style} on:click={goToTop}>
  <span>Top</span>
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.06486 5.82617C1.4361 6.09134 1.98784 6.04835 2.29721 5.73014L6
      1.92154L9.70279 5.73014C10.0122 6.04835 10.5639 6.09134 10.9351
      5.82617C11.3064 5.56099 11.3565 5.08807 11.0472 4.76986L6.67219
      0.269862C6.50595 0.0988673 6.25968 0 6 0C5.74032 0 5.49405 0.0988673
      5.32781 0.269862L0.952828 4.76986C0.64346 5.08807 0.693619 5.56099 1.06486
      5.82617Z"
      fill="#A893F9" />
  </svg>
</div>
